import React from "react";

const BlogHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[38rem] w-[38rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/45" />
      </div>

      {/* Content */}
      <div
        className="
          relative mx-auto max-w-7xl
          px-4 sm:px-6 lg:px-8
          py-16
          sm:py-20
          md:py-24
          lg:py-28
        "
      >
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white">
            Blog
            <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
            Insights & frameworks
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-semibold tracking-tight text-white">
            Learn how strong teams keep improving
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
            Practical guidance on quality systems, disciplined execution, training adoption, and compliance readiness.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
